export function getCallStatusLabel(status: string, t: (key: string) => string): string {
  const labels: Record<string, string> = {
    pending: t('pages:campaigns.callStatus.pending'),
    queued: t('pages:campaigns.callStatus.queued'),
    dialing: t('pages:campaigns.callStatus.dialing'),
    analyzing: t('pages:campaigns.callStatus.analyzing'),
    ringing: t('pages:campaigns.callStatus.ringing'),
    in_progress: t('pages:campaigns.callStatus.inProgress'),
    finalizing: t('pages:campaigns.callStatus.finalizing'),
    completed: t('pages:campaigns.callStatus.completed'),
    no_interaction: t('pages:campaigns.callStatus.noInteraction'),
    failed: t('pages:campaigns.callStatus.failed'),
    no_answer: t('pages:campaigns.callStatus.noAnswer'),
    no_answer_timeout: t('pages:campaigns.callStatus.noAnswerTimeout'),
    busy: t('pages:campaigns.callStatus.busy'),
    cancelled: t('pages:campaigns.callStatus.cancelled'),
    transfer_unanswered: t('pages:campaigns.callStatus.transferUnanswered'),
    congestion: t('pages:campaigns.callStatus.congestion'),
    voicemail: t('pages:campaigns.callStatus.voicemail'),
    invalid_number: t('pages:campaigns.callStatus.invalidNumber'),
    config_error: t('pages:campaigns.callStatus.configError'),
    declined: t('pages:campaigns.callStatus.declined'),
    unreachable: t('pages:campaigns.callStatus.unreachable'),
    timeout: t('pages:campaigns.callStatus.timeout'),
    mismatch: t('pages:campaigns.callStatus.mismatch'),
    api_timeout: t('pages:campaigns.callStatus.apiTimeout'),
    terminated_manual: t('pages:campaigns.callStatus.terminatedManual'),
  };
  return labels[status] || status;
}
